/* eslint-disable indent */
import { Dispatch } from 'redux';
import { createActions, createAction } from 'redux-actions';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _isEmpty from 'lodash/isEmpty';

import { CONFIG, POSTS, SET_BLOCK_POPULATING } from '../constants/actionTypes/thirdPartyContent';
import { IFetchQueryParams } from '../types/content';
import configs from '../constants/configs';
import { request } from '../common/request';

const defaultVendor = 'staffbase';

export const setSBBlockPopulating = createAction(SET_BLOCK_POPULATING, (payload: any) => ({
    ...payload,
    vendor: _get(payload, 'vendor', defaultVendor),
}));

export const resetPosts = createAction(POSTS.RESET_POSTS, (payload: any) => ({
    ...payload,
    vendor: _get(payload, 'vendor', defaultVendor),
}));

export const [
    {
        // @ts-ignore createActions nests the return if the type constant has a slash but the types don't expect that
        thirdPartyContentTypes: { fetchConfigBegin, fetchConfigError, fetchConfigSuccess },
    },
    {
        // @ts-ignore createActions nests the return if the type constant has a slash but the types don't expect that
        thirdPartyContentTypes: { fetchPostsBegin, fetchPostsError, fetchPostsSuccess },
    },
] = [CONFIG, POSTS].map((types) =>
    createActions({
        [types.FETCH_BEGIN]: (payload) => ({ ...payload, vendor: _get(payload, 'vendor', defaultVendor) }),
        [types.FETCH_SUCCESS]: (payload) => ({ ...payload, vendor: _get(payload, 'vendor', defaultVendor) }),
        [types.FETCH_ERROR]: (payload) => ({ ...payload, vendor: _get(payload, 'vendor', defaultVendor) }),
    })
);

const fetchTypeMap = {
    config: {
        endpoint: configs.staffbaseBranch,
        fetchBegin: fetchConfigBegin,
        fetchSuccess: fetchConfigSuccess,
        fetchError: fetchConfigError,
        defaultQueryParams: {},
    },
    posts: {
        endpoint: configs.staffbasePosts,
        fetchBegin: fetchPostsBegin,
        fetchSuccess: fetchPostsSuccess,
        fetchError: fetchPostsError,
        defaultQueryParams: {
            contentType: 'articles',
            manageable: 'true',
        },
    },
};

export const triggerFetch =
    (type: 'config' | 'posts', queryParams: IFetchQueryParams = {}) =>
    async (dispatch: Dispatch) => {
        const { endpoint, fetchBegin, fetchSuccess, fetchError, defaultQueryParams } = fetchTypeMap[type];
        const { offset } = queryParams;

        dispatch(fetchBegin({ isLazyLoading: offset && offset !== '0' }));
        try {
            const data = await request.get(
                `${endpoint}${
                    !_isEmpty(defaultQueryParams) || !_isEmpty(queryParams)
                        ? _reduce(
                              { ...defaultQueryParams, ...queryParams },
                              (acc, val, key) => `${acc}${acc !== '?' ? '&' : ''}${key}=${val}`,
                              '?'
                          )
                        : ''
                }`
            );

            dispatch(fetchSuccess(data));
        } catch (error) {
            dispatch(fetchError({ error: error.message }));
        }
    };
